import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { AppState } from '../../core/redux/appState';
import { Action } from 'redux';


type RemoveFilterProjectAction = {
  type: ActionType.RemoveFilterProject;
  key:  string;
}


/**
 * Dispatch this action to remove a filter project
 * @param key - the key for the project to remove
 */
export const removeFilterProjectAction = (key: string): RemoveFilterProjectAction => ({
  type: ActionType.RemoveFilterProject,
  key:  key,
});


export const removeFilterProjectReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.RemoveFilterProject) {
    return state;
  }
  
  const action = incomingAction as RemoveFilterProjectAction;

  return R.dissocPath(['reportRecipientSelectedProjects', action.key], state);
};
